<template>
<div class="ptlGateway">

  <!-- 상단 헤더 -->
  <header class="ptlHeader">
    <div class="ptlHeaderText">
      <p class="kicker">프로토콜 작업공간</p>
      <h2>프로토콜</h2>
      <p class="sub">
        <template v-if="userName">{{ userName }} 님의 프로토콜 목록입니다.</template>
        <template v-else>프로토콜 목록</template>
      </p>
    </div>
    <div class="ptlHeaderActions">
      <button type="button" class="btnGhost" @click="gotoSwitch">공정도 게이트웨이</button>
      <button type="button" class="btnPrimary" @click="templateSelect(null)">
        <span class="plus">+</span> 새 프로토콜
      </button>
    </div>
  </header>

  <!-- 검색 툴바 -->
  <section class="ptlToolbar">
    <div class="filters">
      <label class="filter">
        <span class="filterLabel">분야</span>
        <select v-model="selectSearchProtocolField" @change="searchConditionChangeFlag=true">
          <option value="">전체분야</option>
          <option value="4">에너지환경</option>
          <option value="3">구조안전</option>
          <option value="1">스마트IT</option>
        </select>
      </label>
      <label class="filter">
        <span class="filterLabel">구분</span>
        <select v-model="selectSearchField" @change="searchConditionChangeFlag=true">
          <option value="">전체</option>
          <option value="FULL">FULL</option>
          <option value="UNIT">UNIT</option>
        </select>
      </label>
      <label class="filter">
        <span class="filterLabel">검색대상</span>
        <select v-model="selectSearchTarget" @change="searchConditionChangeFlag=true">
          <option value="name">프로토콜명(한글)</option>
          <option value="nameEng">프로토콜명(영문)</option>
          <option value="userName">작성자명</option>
        </select>
      </label>
    </div>
    <div class="searchBox">
      <input
        type="text"
        ref="searchInputTag"
        v-model="searchInputData"
        @keydown="checkKeyTimer"
        placeholder="검색어를 입력하세요"
      />
      <button v-if="searchInputData" type="button" class="btnClear" @click="clearTextInput" title="검색어 삭제">&times;</button>
      <button type="button" class="btnSearch" @click="searchConditionChangeFlag=true;getMyProcessWithLoading()">검색</button>
    </div>
  </section>

  <!-- 카드 목록 -->
  <section class="ptlCards" v-if="protocolTemplates && protocolTemplates.length">
    <article
      v-for="(item, idx) in protocolTemplates"
      :key="`${item.protocolId}_${idx}`"
      class="ptlCard"
      :class="item.protocolType === 'UNIT' ? 'unit' : 'full'"
      @click="loadProtocol(item.processId, item.protocolId, item.keyOfProtocol)"
    >
      <div class="cardTop">
        <span class="badgeType">{{ item.protocolType }}</span>
        <span class="badgePublic" :class="publicClass(item.publicActive)">{{ publicLabel(item.publicActive) }}</span>
      </div>
      <h3 class="cardTitle" v-html="item.protocolName"></h3>
      <div class="cardMeta">
        <span class="metaField" v-if="item.protocolFieldName">{{ item.protocolFieldName }}</span>
        <span class="metaConnect">연결 {{ item.connectProtocolCount == null ? 0 : item.connectProtocolCount }}개</span>
      </div>
    </article>
  </section>

  <!-- 빈 상태 -->
  <section class="ptlEmpty" v-else>
    <p class="emptyTitle">표시할 프로토콜이 없습니다</p>
    <p class="emptyDesc">새 프로토콜을 만들면 기본 템플릿이 자동으로 적용됩니다.</p>
    <button type="button" class="btnPrimary" @click="templateSelect(null)">
      <span class="plus">+</span> 새 프로토콜 만들기
    </button>
  </section>

  <!-- 페이지네이션 -->
  <nav class="ptlPaging" v-if="totalPage > 1">
    <button type="button" :disabled="pageNo <= 1" @click="selectPage(pageNo - 1)">이전</button>
    <button
      v-for="p in pageList"
      :key="p"
      type="button"
      :class="{ on: p === pageNo }"
      @click="selectPage(p)"
    >{{ p }}</button>
    <button type="button" :disabled="pageNo >= totalPage" @click="selectPage(pageNo + 1)">다음</button>
  </nav>

  <MakeProcess
    :active="titleModal"
    :selectTemplateData="selectTemplateData"
    Type="protocol|make"
    @confirm="(info)=>confirmMakeProtocol(info)"
    @close="titleModal=false"
    @tempChange="(data)=>tempContentChange(data)"
    :onlyProtocolFlag=true
  ></MakeProcess>
  <loading :visible="loading" />
</div>
</template>

<script>
import CommNew from "@processEditor/CommNew";
import { v4 } from "uuid";

export default {
  mixins:[CommNew],
  components : {
    Loading : _=> import( '@common/loading' ) ,
    MakeProcess: _=> import('@modal/MakeProcess'),
  } ,
  data () {
    return {
      loading : false ,
      protocolTemplates : [] ,
      selectSearchField : '' ,
      selectSearchProtocolField : '',
      selectSearchTarget : 'name' ,
      searchInputData : '' ,
      userName : '' ,
      pageNo : 1 ,
      totalPage : 0 ,
      titleModal: false,
      searchConditionChangeFlag : false,
      selectTemplateData : {},
      selectTemplateChangeData : "",
    }
  },
  computed : {
    pageList () {
      const size = 5 ;
      let start = Math.max( 1 , this.pageNo - Math.floor( size / 2 )) ;
      let end = Math.min( this.totalPage , start + size - 1 ) ;
      start = Math.max( 1 , end - size + 1 ) ;
      const list = [] ;
      for ( let i = start ; i <= end ; i++ ) list.push( i ) ;
      return list ;
    } ,
  },
  async mounted () {
    const
    { name } = await this.$wApi.user.me() ,
    {
      updateData ,
      getNewTemplate ,
      getMyProcess ,
    } = this ;
    updateData({ loading : true , userName : name }) ;

    try {
      await getNewTemplate() ;
      await getMyProcess() ;
    } catch ( error ) {
      this.$router.push({
        path:'/'
      })
    }

    updateData({ loading : false }) ;

    // 워크스페이스 LNB의 "새로 만들기" 진입 처리
    if ( this.$route.query.action === 'create' ) {
      await this.templateSelect( null ) ;
    }
  } ,
  methods:{
    updateData ( obj ) {
      for ( let [ k , v ] of Object.entries( obj )) {
        this[ k ] = v ;
      }
    } ,
    publicLabel ( publicActive ) {
      return publicActive == 0 ? '미공개' : publicActive == 1 ? '일반공개' : '위원/간사공개' ;
    } ,
    publicClass ( publicActive ) {
      return publicActive == 0 ? 'closed' : publicActive == 1 ? 'open' : 'limited' ;
    } ,
    gotoSwitch(){
      this.$router.push({
        path : '/process/gate' ,
        query : {} ,
      }) ;
    },
    nextPage() {
      this.$router.replace({
        path: '/protocol/editor'
      })
    } ,
    tempContentChange(data){
      this.selectTemplateChangeData = data;
    },

    fullProtocolNodeAdd(equipmentKey){
      const materialKey = v4() ;
      const analysisKey = v4();
      return {
        nodes: [
          {
            category: 'MATERIAL',
            key: materialKey ,
            tagKey: materialKey ,
            linkValidation: [
              "PROCESS",
              "MEASUREMENT",
              "ANALYSIS"
            ],
            position: '-483 0',
            tagId: '14',
            shape: null,
            text: '재료',
            parent: [],
          } ,
          {
            category: 'ANALYSIS',
            key: analysisKey ,
            tagKey: analysisKey ,
            linkValidation: [
              "EQUIPMENT",
              "PROCESS",
              "MEASUREMENT",
              "ANALYSIS"
            ],
            parent: [],
            position: '-322 0',
            shape: null,
            tagId: '1761',
            text: '분석목적',
          }
        ] ,
        links: [
          {
            from : materialKey ,
            to : analysisKey ,
          },
          {
            from : analysisKey ,
            to : equipmentKey ,
          }
        ] ,
      }
    },
    async makeTemplateData(item) {
      if( item.protocolType === 'UNIT'){
        item.content = this.selectTemplateChangeData;
      }else{
        item.content = JSON.stringify(this.selectTemplateData.content);
      }
      const equipmentKey = v4() ;
      const protocolKey = v4() ;
      const processNew = await this.$wApi.process.create({
        name : item.name ,
        nameEng : item.nameEng ,
        fieldId: item.fieldId, // 1 : IT 위훤회
        processType: 'ONLY_PROTOCOL' , // NORMAL , TEMPLATE
        active : true ,
        // 과학기술분류
        knsccId: item.requestKnscc.knsccId,
        // 과학기술표준분류코드
        knsccCode: item.requestKnscc.knsccCode,
        // 과학기술표준분류명
        knsccCodeName: item.requestKnscc.knsccCodeName,
        // 대분류코드
        categoryLargeCode: item.requestField.categoryLargeCode,
        // 대분류명
        categoryLargeCodeName: item.requestField.categoryLargeCodeName,
        // 중분류코드
        categoryMiddleCode: item.requestField.categoryMiddleCode,
        // 중분류명
        categoryMiddleCodeName: item.requestField.categoryMiddleCodeName,
        // 소분류코드(공정식별번호)
        categorySmallCode: item.requestField.categorySmallCode,
        // 소분류코드명
        categorySmallCodeName: item.requestField.categorySmallCodeName,
        // 소소분류코드(하부공정식별번호)
        categoryMicroCode: item.requestField.categoryMicroCode,
        // 소소분류코드명
        categoryMicroCodeName: item.requestField.categoryMicroCodeName,
      }) ;
      const { processId : processNew_processId , name : processNew_name, nameEng : processNew_nameEng } = processNew ;
      const processNew_fieldId_split = processNew.fieldId.split(">");
      const processNew_fieldId = processNew_fieldId_split.length > 1 ? processNew_fieldId_split[processNew_fieldId_split.length-1] : processNew_fieldId_split[0];

      let tempData = {
        nodes: [
          {
            category: 'EQUIPMENT',
            hasProtocol : true ,
            key: equipmentKey ,
            tagKey: equipmentKey ,
            linkValidation: [ 'PROTOCOL' ],
            position: '-161 0',
            protocol : [] ,
            tagId: item.tagId == -1 || item.tagId == null ? '1795' : item.tagId,
            shape: null,
            text: item.tagId == -1 || item.tagId == null ? '장비명' : item.tagName,
            parent: [],
          } ,
          {
            category: 'PROTOCOL',
            key: protocolKey ,
            linkValidation: [  ],
            parent: [],
            tagId: item.tagId == -1 || item.tagId == null ? '1795' : item.tagId ,
            position: '0 0',
            shape: null,
            tagKey: protocolKey ,
            text: 'Protocol',
          }
        ] ,
        links: [
          {
            from : equipmentKey ,
            to : protocolKey ,
          }
        ] ,
      } ;

      if ( item.protocolType == 'FULL' ) {
        const addNodes = this.fullProtocolNodeAdd(equipmentKey);
        tempData = {
          ...tempData  ,
          nodes : [
            ...tempData.nodes ,
            ...addNodes.nodes ,
          ] ,
          links : [
            ...tempData.links ,
            ...addNodes.links ,
          ] ,
        }
      } ;

      const rslt = await this.$wApi.process.put({ json : tempData }, processNew_processId ) ;

      const { processId : rslt_processId , processName : rslt_processName } = rslt ;
      const loadProcess = await this.$wApi.process.detail( null , processNew_processId ) ;
      const keyOfProtocol = v4() ;
      const protocolNew = await this.$wApi.protocol.create({
        processId : processNew_processId ,
        keyOfProtocol : equipmentKey ,
        name : processNew_name ,
        nameEng : processNew_nameEng,
        protocolType : item.protocolType,
        fieldId: processNew_fieldId,
        active : true ,
        // 과학기술분류
        knsccId: item.requestKnscc.knsccId,
        // 과학기술표준분류코드
        knsccCode: item.requestKnscc.knsccCode,
        // 과학기술표준분류명
        knsccCodeName: item.requestKnscc.knsccCodeName,
        // 대분류코드
        categoryLargeCode: item.requestField.categoryLargeCode,
        // 대분류명
        categoryLargeCodeName: item.requestField.categoryLargeCodeName,
        // 중분류코드
        categoryMiddleCode: item.requestField.categoryMiddleCode,
        // 중분류명
        categoryMiddleCodeName: item.requestField.categoryMiddleCodeName,
        // 소분류코드(공정식별번호)
        categorySmallCode: item.requestField.categorySmallCode,
        // 소분류코드명
        categorySmallCodeName: item.requestField.categorySmallCodeName,
        // 소소분류코드(하부공정식별번호)
        categoryMicroCode: item.requestField.categoryMicroCode,
        // 소소분류코드명
        categoryMicroCodeName: item.requestField.categoryMicroCodeName,
      }) ;

      let loadProtocol = await this.$wApi.protocol.gets({
        processId : processNew_processId ,
        isMemo : true ,
        isConent : true ,
        isComment : true ,
      }) ;
      loadProtocol = loadProtocol[0] ;

      let dataJSON;
      if( !item.content ){
        let rlt = await this.getNewTemplate();
        item.content = rlt.content;
      }
      item.content = JSON.parse( item.content );
      if( typeof item.content === 'string' ) item.content = JSON.parse( item.content );
      if(item.content) {
        dataJSON = item.content.issues.map( info => {
          if ( info.protocolId ) {
            info.protocolId = `${ loadProtocol.id }` ;
          }
          return info ;
        }) ;
      } else {
        dataJSON = loadProtocol.json.issues.map( info => {
          if ( info.protocolId ) {
            info.protocolId = `${ loadProtocol.id }` ;
          }
          return info ;
        }) ;
      }
      const data = await this.$wApi.protocol.put({
        protocolId : loadProtocol.id ,
        name : processNew_name ,
        nameEng : processNew_nameEng ,
        fieldId : processNew_fieldId,
        protocolType : item.protocolType,
        keyOfProtocol : equipmentKey ,
        content : JSON.stringify({ issues : dataJSON, init : true }) ,
        active : true ,
        // 과학기술분류
        knsccId: item.requestKnscc.knsccId,
        // 과학기술표준분류코드
        knsccCode: item.requestKnscc.knsccCode,
        // 과학기술표준분류명
        knsccCodeName: item.requestKnscc.knsccCodeName,
        // 대분류코드
        categoryLargeCode: item.requestField.categoryLargeCode,
        // 대분류명
        categoryLargeCodeName: item.requestField.categoryLargeCodeName,
        // 중분류코드
        categoryMiddleCode: item.requestField.categoryMiddleCode,
        // 중분류명
        categoryMiddleCodeName: item.requestField.categoryMiddleCodeName,
        // 소분류코드(공정식별번호)
        categorySmallCode: item.requestField.categorySmallCode,
        // 소분류코드명
        categorySmallCodeName: item.requestField.categorySmallCodeName,
        // 소소분류코드(하부공정식별번호)
        categoryMicroCode: item.requestField.categoryMicroCode,
        // 소소분류코드명
        categoryMicroCodeName: item.requestField.categoryMicroCodeName,
      });

      /** 로그 등록 */
      await this.$wApi.trace.log({
        type : 'PR', //PD 공정도, PR 프로토콜
        code : 'N', //N 생성 M 수정 S 검색 R 조회
        subCode : '01',
        keyword : '',
        result : 0,
        ptlId : loadProtocol.id
      });
      /** 로그 등록 */

      await this.$wApi.dictionary.setDictionaryLinkForNewProtocol({
        processId: processNew_processId,
      });

      this.$router.push({
        path : '/protocol/editor' ,
        query : {
          processId : processNew_processId ,
          editorType : 'protocol' ,
          protocolId    : loadProtocol.id ,
          keyOfProtocol : protocolNew.key ,
        } ,
      }) ;
    },
    async templateSelect(clickItemInfo) {
      // 기본 템플릿 자동 적용: 템플릿 선택 화면 없이 항상 기본 템플릿으로 시작
      if( clickItemInfo === null || clickItemInfo === undefined ){
        clickItemInfo = await this.getNewTemplate();
      }
      this.selectTemplateData = JSON.parse(JSON.stringify(clickItemInfo));
      this.titleModal = true;
      const loadTemplate = async (info) => {
        this.loading = true;
        clickItemInfo.tagName = clickItemInfo.name;
        clickItemInfo.name = info.kr;
        clickItemInfo.nameEng = info.en;
        clickItemInfo.requestField = info.requestField;
        clickItemInfo.requestKnscc = info.requestKnscc;
        clickItemInfo.fieldId = info.field[info.field.length-1];
        clickItemInfo.protocolType = info.type;
        await this.makeTemplateData(clickItemInfo);
        this.loading = false;
      }
      const emptyTemplate = async (info) => {
        this.loading = true;
        await this.makeTemplateData({
          name: info.kr,
          nameEng: info.en,
          fieldId: info.field[info.field.length-1],
          requestField: info.requestField,
          requestKnscc: info.requestKnscc,
          protocolType : 'FULL'
        });
        this.loading = false;
      }
      if(!clickItemInfo || !clickItemInfo.id) {
        this.confirmMakeProtocol = emptyTemplate;
      }else {
        this.confirmMakeProtocol = loadTemplate;
      }
    },
    confirmMakeProtocol(){},
    async loadProtocol ( processId, protocolId , keyOfProtocol ) {
      this.setProtocolId( protocolId ) ;
      this.setInnerProtocolId({innerProtocolId : protocolId});
      this.$router.push({
        path : '/protocol/editor' ,
        query : {
          processId ,
          editorType : 'protocol' ,
          protocolId : protocolId ,
          keyOfProtocol : keyOfProtocol ,
        } ,
      }) ;

    } ,
    async getNewTemplate () {
      const rslt = await this.$wApi.tag.template.get_new( null , -1 ) ;
      return rslt ;
    } ,
    async getMyProcessWithLoading () {
      this.loading = true ;
      try {
        await this.getMyProcess() ;
      } finally {
        this.loading = false ;
      }
    } ,
    async getMyProcess () {
      if(this.searchConditionChangeFlag === true){
        this.pageNo = 1;
        this.searchConditionChangeFlag = false;
      }
      const response = await this.$wApi.protocol.search({
        pageNo : this.pageNo,
        perPage : 10 ,
        isMyData : 1 ,
        protocolType : this.selectSearchField,
        targetField : this.selectSearchTarget,
        query : this.searchInputData,
        fieldId : this.selectSearchProtocolField
        // processType : 'NORMAL' , // NORMAL , ONLY_PROTOCOL , TEMPLATE
      });

      this.totalPage = response.totalPages ;
      this.protocolTemplates = response.content ;
    } ,

    async selectPage ( idx ) {
      if ( idx < 1 || ( this.totalPage && idx > this.totalPage )) return ;
      this.pageNo = idx;
      await this.getMyProcessWithLoading() ;
    } ,

    async checkKeyTimer (event) {
      if( event.keyCode === 13 ){
        this.searchConditionChangeFlag = true ;
        await this.getMyProcessWithLoading() ;
      }
    } ,
    async clearTextInput () {
      this.searchInputData = '';
      this.searchConditionChangeFlag = true ;
      await this.getMyProcessWithLoading() ;
    } ,
  }
}
</script>

<style lang="scss" scoped>
/* ============================================
   프로토콜 게이트웨이 — 계측장비 테마
   엔지니어링 그리드 + 그라파이트/시그널 시안
   이 화면 전용 스타일 (공용 scss 미사용)
   ============================================ */
.ptlGateway {
  --ptl-ink: #1a2236;
  --ptl-ink-soft: #6b7280;
  --ptl-line: #e7e9ee;
  --ptl-navy: #032C7C;
  --ptl-navy-soft: #0a3d9e;
  --ptl-bg: #f6f7f9;

  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: clamp(16px, 3vw, 36px);
  background-color: var(--ptl-bg);
  color: var(--ptl-ink);
  font-family: "Pretendard", "Malgun Gothic", "맑은 고딕", "Apple SD Gothic Neo", sans-serif;

  *, *::before, *::after { box-sizing: border-box; }
  button { font: inherit; cursor: pointer; }
}

/* ---------- 헤더 ---------- */
.ptlHeader {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;

  .kicker {
    margin: 0 0 4px;
    font-size: 12px;
    font-weight: 500;
    color: var(--ptl-navy);
  }
  h2 {
    margin: 0;
    font-size: clamp(20px, 2vw, 26px);
    font-weight: 700;
    letter-spacing: -0.01em;
  }
  .sub {
    margin: 4px 0 0;
    font-size: 14px;
    color: var(--ptl-ink-soft);
  }
}
.ptlHeaderActions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.btnPrimary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  border: 0;
  border-radius: 10px;
  background: var(--ptl-navy);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  transition: background 0.2s, transform 0.15s;

  .plus {
    font-size: 15px;
    line-height: 1;
    opacity: 0.85;
  }
  &:hover { background: var(--ptl-navy-soft); }
  &:active { transform: scale(0.97); }
}
.btnGhost {
  padding: 10px 16px;
  border: 1px solid var(--ptl-line);
  border-radius: 10px;
  background: #fff;
  color: var(--ptl-ink-soft);
  font-size: 13.5px;
  font-weight: 600;
  transition: border-color 0.2s, color 0.2s;

  &:hover { border-color: var(--ptl-navy); color: var(--ptl-navy); }
}

/* ---------- 검색 툴바 ---------- */
.ptlToolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 16px;
  margin-bottom: 20px;
  background: #fff;
  border: 1px solid var(--ptl-line);
  border-radius: 14px;
}
.filters {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.filter {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 130px;

  .filterLabel {
    font-size: 11px;
    font-weight: 500;
    color: var(--ptl-ink-soft);
  }
  select {
    height: 38px;
    padding: 0 10px;
    border: 1px solid var(--ptl-line);
    border-radius: 9px;
    background: #fff;
    font-size: 13.5px;
    color: var(--ptl-ink);
    outline: none;

    &:focus { border-color: var(--ptl-navy); }
  }
}
.searchBox {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 280px;
  max-width: 460px;
  position: relative;

  input {
    flex: 1;
    min-width: 0;
    height: 42px;
    padding: 0 36px 0 14px;
    border: 1px solid var(--ptl-line);
    border-radius: 10px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus {
      border-color: var(--ptl-navy);
      box-shadow: 0 0 0 3px rgba(3, 44, 124, 0.1);
    }
  }
  .btnClear {
    position: absolute;
    right: 78px;
    width: 24px; height: 24px;
    border: 0;
    border-radius: 50%;
    background: var(--ptl-line);
    color: var(--ptl-ink-soft);
    font-size: 14px;
    line-height: 1;
  }
  .btnSearch {
    height: 42px;
    padding: 0 18px;
    border: 0;
    border-radius: 10px;
    background: var(--ptl-navy);
    color: #fff;
    font-size: 13.5px;
    font-weight: 700;

    &:hover { background: var(--ptl-navy-soft); }
  }
}

/* ---------- 카드 그리드 ---------- */
.ptlCards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  gap: 16px;
}
.ptlCard {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px 18px 14px;
  background: #fff;
  border: 1px solid var(--ptl-line);
  border-radius: 14px;
  cursor: pointer;
  transition: transform 0.18s, box-shadow 0.18s, border-color 0.18s;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(26, 34, 54, 0.08);
    border-color: #b9c5e0;
  }
}
.cardTop {
  display: flex;
  align-items: center;
  gap: 6px;
}
.badgeType {
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.03em;
  background: #e9eefa;
  color: var(--ptl-navy);

  .unit & {
    background: #eef1f5;
    color: #4b5260;
  }
}
.badgePublic {
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;

  &.closed  { background: #f0f1f4; color: #828896; }
  &.open    { background: #e4f4ec; color: #18834f; }
  &.limited { background: #fbf1de; color: #a87a15; }
}
.cardTitle {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--ptl-ink);
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.8em;
}
.cardMeta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: auto;
  font-size: 12px;
  color: var(--ptl-ink-soft);

  .metaField {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .metaConnect {
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 600;
  }
}

/* ---------- 빈 상태 ---------- */
.ptlEmpty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 72px 20px;
  background: #fff;
  border: 1px dashed #c9cfd6;
  border-radius: 14px;
  text-align: center;

  .emptyTitle { margin: 0; font-size: 17px; font-weight: 700; }
  .emptyDesc  { margin: 0 0 12px; font-size: 13px; color: var(--ptl-ink-soft); }
}

/* ---------- 페이지네이션 ---------- */
.ptlPaging {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 28px;
  padding-bottom: 8px;

  button {
    min-width: 36px;
    height: 36px;
    padding: 0 10px;
    border: 1px solid var(--ptl-line);
    border-radius: 9px;
    background: #fff;
    color: var(--ptl-ink-soft);
    font-size: 12.5px;
    font-weight: 600;

    &:hover:not(:disabled) { border-color: var(--ptl-navy); color: var(--ptl-navy); }
    &:disabled { opacity: 0.4; cursor: default; }
    &.on {
      background: var(--ptl-navy);
      border-color: var(--ptl-navy);
      color: #fff;
    }
  }
}

/* ---------- 반응형 ---------- */
@media (max-width: 768px) {
  .ptlToolbar { flex-direction: column; align-items: stretch; }
  .filters { width: 100%; }
  .filter { flex: 1 1 calc(33.333% - 7px); min-width: 0; }
  .searchBox { max-width: none; }
}

@media (max-width: 480px) {
  .ptlGateway { padding: 12px; }
  .ptlHeader { align-items: stretch; flex-direction: column; }
  .ptlHeaderActions {
    width: 100%;
    .btnPrimary, .btnGhost { flex: 1; justify-content: center; text-align: center; }
  }
  .filter { flex: 1 1 100%; }
  .ptlCards { grid-template-columns: 1fr; }
  .searchBox .btnSearch { padding: 0 14px; }
  .searchBox .btnClear { right: 70px; }
}
</style>
